import Channel1 from './assets/channel_3.png';
import Channel2 from './assets/channel_2.png';
import Channel3 from './assets/channel_1.png';

export const listOfChannels = [
  {
    name: 'channel-3',
    img: Channel3,
  },
  {
    name: 'channel-2',
    img: Channel2,
  },
  {
    name: 'channel-1',
    img: Channel1,
  },
];



// WEBPACK FOOTER //
// ./src/js/components/pages/newLandingPage/block-slider/config.js